const mylesEventProject = {
  id: "mylesEvent",
  title: "Myles Events",
  titleIntro: "What are Myles Event?",
  role: "Event Designer, Plugin Developer",
  startDate: "January 2025",
  // endDate: "",
  banner: "/images/myles/windboss.png",
  detailBanner: "/images/myles/windboss.png",
  overview: [
    "Myles events are hosted 100 player Battle Royale events similar in style to SpeedSilver events.",
    "Players can join into teams of up to 5 players, and the last team standing wins. The server is open for 4 hours everyday.",
    "These events are turned into long form youtube content for Myles.",
    "These events are developed as Spigot plugins and feature complex non-vanilla mechanics.",
  ],
  contributeTitle: "What I Contributed:",
  contribution: [
    "- I design the specifics of the events mechanics and features.",
    "- I develop the plugins implementing these features.",
    " ",
    "Because this is an ongoing project, most of this event's features will not be added until after the video created from this event has released."
  ],
  //nextPreview: "Here are some of my favorite features of this project:",
  // features: [
  //   {
  //     id: "customMechanics",
  //     title: "Wind Boss Bossfight",
  //     pretext: "I developed a complex dark souls inspired bossfight.",
  //     description: [
  //       "I designed this bossfight to force players to take their time, work together, and learn the patterns of the bosses attack in order to defeat it.",

  //     ],
  //     featuredImage: "/images/myles/windboss.png",
      // images: [
      //   "/mylesEvent/mechanics1.png",
      //   "/mylesEvent/mechanics2.png",
      //   "/mylesEvent/mechanics3.png"
      // ]
    // },
    // {
    //   id: "eventManagement",
    //   title: "Event Management",
    //   pretext: "I created a comprehensive event management system.",
    //   description: [
    //     "The system allowed for real-time control of the event flow, including starting and stopping different phases.",
    //     "It included features for managing participants, tracking progress, and adjusting difficulty on the fly."
    //   ],
    //   video: "https://www.youtube.com/embed/example1"
    // },
    // {
    //   id: "customItems",
    //   title: "Custom Items",
    //   pretext: "I designed and implemented over 20 custom items for the event.",
    //   description: [
    //     "Each item had unique properties and abilities that players could use during the event.",
    //     "The items were balanced to ensure fair gameplay while still providing exciting and powerful effects."
    //   ],
    //   featuredImage: "/mylesEvent/items.png",
    //   images: [
    //     "/mylesEvent/item1.png",
    //     "/mylesEvent/item2.png",
    //     "/mylesEvent/item3.png"
    //   ]
    // }
  // ]
};

export default mylesEventProject; 